import logo from './logo.svg';
import './App.css';
import Signup from './Routes/Signup';
import AllRoutes from './Routes/AllRoutes';

function App() {
  return (
    <div className="bg-primary-50">

      <AllRoutes />

    </div>
  );
}

export default App;
